export default __webpack_public_path__ + "static/simple-histogram-a63eafd6836340df4165f5719ec590ea.png";